// import React, { useEffect, useState } from "react";
// import { Modal, DatePicker, Flex, Spin, message } from "antd";
// import { CiCirclePlus } from "react-icons/ci";
// import FilterIcon from "../../../../../Assets/Images/SideMenuSVG/FilterIcon.svg";
// import nodatafound from "../../../../../Assets/Images/Svg/nodatafound.svg";
// import AddDevices from "./addDevices";
// import MappedDevicesTable from "./mappedDevicesTable";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchPatMappedRpmDevList } from "../../../../../Redux/actions/rpmActions";
// import PatientService from "../../../../../Services/PatientService";
// import { clearPatientFilter, fetchPatients, fetchPatientsCount } from "../../../../../Redux/actions/patientActions";
// import { FaFilter } from "react-icons/fa";

// function Devices({ data, currPageView, handleCancel, handleNext, handlePrevious }) {
//     const [deviceModal, setDeviceModal] = useState(false);
//     const [currLocalMappedDev, setCurrLocalMappedDev] = useState([]);
//     const [loader, setLoader] = useState(false);
//     const dispatch = useDispatch();
//     const { registrationPayload } = useSelector((state) => state.patients);
//     const { isLoading, mappedDevicesList } = useSelector((state) => state.rpm);
//     const { selectedEditPatient, patientFilter } = useSelector((state) => state.patients);
//     const loggedUserObj = sessionStorage.getItem('login_result');
//     const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

//     // useEffect(() => {
//     //     const payload = {
//     //         status: 1
//     //     }
//     //     dispatch(fetchPatMappedRpmDevList(payload));
//     // }, [])

//     useEffect(() => {
//         if (selectedEditPatient?.patientDevicesList) {
//             setCurrLocalMappedDev(selectedEditPatient?.patientDevicesList);
//         }
//     }, [selectedEditPatient]);

//     const handleNewDeviceMod = () => {
//         setDeviceModal(!deviceModal);
//     }

//     const handlePatientFinalSave = async () => {
//         if (!registrationPayload) {
//             message.error('Please fill data in all tabs.');
//             return;
//         }

//         setLoader(true);
//         const payload = {
//             ...registrationPayload,
//             patientDevicesList: currLocalMappedDev.map((item) => {
//                 return {
//                     ...item,
//                     modifiedBy: loggedUser?.user?.userId,
//                 }
//             }),
//         }

//         // Updated patient list fetching payload 
//         const patPayload = { pageNo: 1 };
//         if (loggedUser?.user?.rolecode === "ACCT_ADM") {
//             patPayload.account_Id = loggedUser.user.account_Id;
//         }
//         else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
//             patPayload.account_Id = loggedUser.user.account_Id;
//             patPayload.clinic_Id = loggedUser.user.clinic_Id;
//         }

//         if (selectedEditPatient) {
//             try {
//                 await PatientService.EditPatientData(payload);
//                 message.success('Patient Details updated successfully!!');
//                 // Update patient list
//                 dispatch(fetchPatients(patPayload));
//                 setLoader(false);
//                 handleCancel();
//                 if (patientFilter) dispatch(clearPatientFilter(false));
//             }
//             catch (e) {
//                 setLoader(false);
//                 console.log(e);
//             }
//         }
//         else {
//             try {
//                 await PatientService.AddPatient(payload);
//                 message.success('Patient created successfully!!');
//                 // Update patient list
//                 dispatch(fetchPatients(patPayload));
//                 dispatch(fetchPatientsCount(patPayload));
//                 handleCancel();
//                 setLoader(false);
//             }
//             catch (e) {
//                 setLoader(false);
//                 console.log(e);
//                 e && message.error(e.response.data.message);
//             }
//         }

//     }

//     const handlSetLocalMappedDevices = (mappingObj) => {
//         setCurrLocalMappedDev((prevState) => [...prevState, mappingObj]);
//     }

//     // return (
//     //     <>
//     //         <div>
//     //             <div className="flex justify-between items-center py-3 px-6">
//     //                 <div className="">
//     //                     <h1 className="font-bold text-xl">Devices</h1>
//     //                 </div>
//     //                 <div className="flex gap-4">
//     //                     <div>
//     //                         <button
//     //                             onClick={handleNewDeviceMod}
//     //                             className="w-20 h-9 px-2 flex bg-[#F1FFF9] items-center gap-2 border border-[#3B98B9] rounded-md"
//     //                         >
//     //                             <span className="w-5 h-5">
//     //                                 <CiCirclePlus className="w-full text-[#189FAA] h-full" />
//     //                             </span>
//     //                             <span className="">New</span>
//     //                         </button>
//     //                     </div>
//     //                     <div>
//     //                         <button
//     //                             className="w-20 h-9 px-2 flex items-center rounded-md gap-2 bg-[#189FAA]"
//     //                         >
//     //                             <span>
//     //                                 <img src={FilterIcon} alt="Icon" />
//     //                             </span>
//     //                             <span className="text-white"> Filter</span>
//     //                         </button>
//     //                     </div>
//     //                 </div>
//     //             </div>

//     //             <div className={`${isLoading === false && currLocalMappedDev?.length === 0 ? 'w-full flex justify-center items-center' : 'overflow-y-scroll h-[23rem] scrollWidth'}`}>
//     //                 {isLoading && currLocalMappedDev?.length === 0 ? (
//     //                     <div className="flex items-center justify-center mt-[10%]">
//     //                         <Flex align="center" gap="middle">
//     //                             <Spin size="large" tip="Loading" />
//     //                         </Flex>
//     //                     </div>
//     //                 ) :
//     //                     currLocalMappedDev?.length === 0 ?
//     //                         (<div className="flex flex-col items-center justify-center">
//     //                             <img src={nodatafound} alt="nodatafound" className="h-32 w-32" />
//     //                             <p className="font-medium text-xl">No data found!!</p>
//     //                         </div>)
//     //                         :
//     //                         (
//     //                             <div>
//     //                                 <MappedDevicesTable
//     //                                     data={currLocalMappedDev}
//     //                                     totalCount={currLocalMappedDev?.length}
//     //                                 />
//     //                             </div>
//     //                         )}

//     //             </div>
//     //             <div className="mt-8">
//     //                 <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 ">
//     //                     <button
//     //                         disabled={loader}
//     //                         className={`${currPageView > 1 ? 'block' : 'hidden'} md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50`}
//     //                         onClick={handlePrevious}
//     //                     >
//     //                         Previous
//     //                     </button>
//     //                     <button
//     //                         disabled={loader}
//     //                         className="md:min-w-24 w-[3rem] md:w-24  h-8 p-1 bg-brand-White rounded-lg border text-brand-primaryColor border-brand-primaryColor font-semibold custom-button-shadow disabled:cursor-not-allowed disabled:opacity-50"
//     //                         onClick={handleCancel}
//     //                     >
//     //                         Cancel
//     //                     </button>
//     //                     <button
//     //                         disabled={loader}
//     //                         className="md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50"
//     //                         onClick={handlePatientFinalSave}
//     //                     >
//     //                         {selectedEditPatient ? 'Update' : 'Save'}
//     //                     </button>
//     //                 </div>
//     //             </div>
//     //         </div>
//     //         <Modal
//     //             title="New Devices"
//     //             footer={[]}
//     //             open={deviceModal}
//     //             onCancel={handleNewDeviceMod}
//     //         >
//     //             <AddDevices handleNewDeviceMod={handleNewDeviceMod} handlSetLocalMappedDevices={handlSetLocalMappedDevices} />
//     //         </Modal>
//     //     </>
//     // );
//     return (
//         <>
//             <div>
//                 <div className="flex justify-between items-center py-3 px-6">
//                     <div className="">
//                         <h1 className="font-bold text-xl">Devices</h1>
//                     </div>
//                     <div className="flex gap-4">
//                         <div>
//                             <button
//                                 onClick={handleNewDeviceMod}
//                                 className="w-20 h-9 px-2 flex bg-[#F1FFF9] items-center gap-2 border border-[#3B98B9] rounded-md"
//                             >
//                                 <span className="w-5 h-5">
//                                     <CiCirclePlus className="w-full text-[#189FAA] h-full" />
//                                 </span>
//                                 <span className="">New</span>
//                             </button>
//                         </div>
//                         <div>
//                             <button className="w-10 h-9 px-2 flex items-center justify-center rounded-md gap-2 bg-brand-primaryColor">
//                                 <span>
//                                     <FaFilter className="text-white" />
//                                 </span>
//                                 {/* <span className="text-white"> Filter</span> */}
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 <div
//                     className={`${isLoading === false && currLocalMappedDev?.length === 0
//                             ? "w-full flex justify-center items-center"
//                             : "overflow-y-scroll h-[23rem] scrollWidth"
//                         }`}
//                 >
//                     {isLoading && currLocalMappedDev?.length === 0 ? (
//                         <div className="flex items-center justify-center mt-[10%]">
//                             <Flex align="center" gap="middle">
//                                 <Spin size="large" tip="Loading" />
//                             </Flex>
//                         </div>
//                     ) : currLocalMappedDev?.length === 0 ? (
//                         <div className="flex flex-col items-center justify-center">
//                             <img src={nodatafound} alt="nodatafound" className="h-32 w-32" />
//                             <p className="font-medium text-xl">No data found!!</p>
//                         </div>
//                     ) : (
//                         <div>
//                             <MappedDevicesTable
//                                 data={currLocalMappedDev}
//                                 totalCount={currLocalMappedDev?.length}
//                             />
//                         </div>
//                     )}
//                 </div>
//                 <div className="mt-8">
//                     <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 ">
//                         <button
//                             disabled={loader}
//                             className={`${currPageView > 1 ? "block" : "hidden"
//                                 } md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white`}
//                             onClick={handlePrevious}
//                         >
//                             Previous
//                         </button>
//                         <button
//                             disabled={loader}
//                             className="md:min-w-24 w-[3rem] md:w-24  h-8 p-1 bg-brand-White rounded-lg border border-brand-primaryColor text-brand-primaryColor font-semibold custom-button-shadow"
//                             onClick={handleCancel}
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             disabled={loader}
//                             className="md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50"
//                             onClick={handlePatientFinalSave}
//                         >
//                             {selectedEditPatient ? "Update" : "Save"}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//             <Modal
//                 title="New Devices"
//                 footer={[]}
//                 open={deviceModal}
//                 onCancel={handleNewDeviceMod}
//             >
//                 <AddDevices
//                     handleNewDeviceMod={handleNewDeviceMod}
//                     handlSetLocalMappedDevices={handlSetLocalMappedDevices}
//                 />
//             </Modal>
//         </>
//     );
// }

// export default Devices;

import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Modal, Flex, Spin, message } from "antd";
import { CiCirclePlus } from "react-icons/ci";
import { FaFilter } from "react-icons/fa";
import nodatafound from "../../../../../Assets/Images/Svg/nodatafound.svg";
import AddDevices from "./addDevices";
import MappedDevicesTable from "./mappedDevicesTable";
import { useDispatch, useSelector } from "react-redux";
import PatientService from "../../../../../Services/PatientService";
import { clearPatientFilter, fetchPatients, fetchPatientsCount } from "../../../../../Redux/actions/patientActions";

function Devices({ currPageView, handleCancel, handleNext, handlePrevious, handleFinalSave, isRpmEnabled,fetchUpdatedData }, ref) {
    const [deviceModal,        setDeviceModal]        = useState(false);
    const [currLocalMappedDev, setCurrLocalMappedDev] = useState([]);
    const [loader,             setLoader]             = useState(false);
    const dispatch = useDispatch();
    const { registrationPayload }                   = useSelector((s) => s.patients);
    const { isLoading }          = useSelector((s) => s.rpm);
    const { selectedEditPatient, patientFilter }    = useSelector((s) => s.patients);
    const loggedUserObj = sessionStorage.getItem('login_result');
    const loggedUser    = loggedUserObj ? JSON.parse(loggedUserObj) : null;

    useEffect(() => {
        if (selectedEditPatient?.patientDevicesList) setCurrLocalMappedDev(selectedEditPatient.patientDevicesList);
    }, [selectedEditPatient]);

    // ── Expose collectValues ──────────────────────────────────────────────────

    useImperativeHandle(ref, () => ({
        collectValues: () => {
            // Devices are local state — nothing to dispatch yet, handled in final save
        }
    }));

    // ── Final save — validate first, then API ─────────────────────────────────

    const handlePatientFinalSave = async () => {
        if (!registrationPayload) { message.error('Please fill data in all tabs.'); return; }

        // Build final payload with devices
        const finalPayload = {
            ...registrationPayload,
            patientDevicesList: currLocalMappedDev.map((item) => ({ ...item, modifiedBy: loggedUser?.user?.userId })),
        };
        console.log("finalPayload ",finalPayload);
        // Ask parent to validate ALL tabs against finalPayload
        const isValid = await handleFinalSave(finalPayload);
        if (!isValid) return; // parent highlighted the error tabs, stop here

        // All valid — call API
        const patPayload = { pageNo: 1 };
        if (loggedUser?.user?.rolecode === "ACCT_ADM")   patPayload.account_Id = loggedUser.user.account_Id;
        if (loggedUser?.user?.rolecode === "CLINIC_ADM") { patPayload.account_Id = loggedUser.user.account_Id; patPayload.clinic_Id = loggedUser.user.clinic_Id; }

        setLoader(true);
        try {
            if (selectedEditPatient) {
                await PatientService.EditPatientData(finalPayload);
                message.success('Patient Details updated successfully!!');
                fetchUpdatedData();
            } else {
                await PatientService.AddPatient(finalPayload);
                message.success('Patient created successfully!!');
                fetchUpdatedData();
            }
            handleCancel();
        } catch (e) {
            console.log(e);
            e?.response?.data?.message && message.error(e.response.data.message);
        } finally {
            setLoader(false);
        }
    };

    const handlSetLocalMappedDevices = (obj) => setCurrLocalMappedDev((p) => [...p, obj]);

    return (
        <>
            <div>
                <div className="flex justify-between items-center py-3 px-6">
                    <h1 className="font-bold text-xl">Devices</h1>
                    <div className="flex gap-4">
                        <button onClick={() => setDeviceModal(true)} disabled={!isRpmEnabled} className="w-20 h-9 px-2 flex bg-[#F1FFF9] items-center gap-2 border border-[#3B98B9] rounded-md disabled:opacity-50 disabled:cursor-not-allowed">
                            <CiCirclePlus className="w-5 h-5 text-[#189FAA]" /><span>New</span>
                        </button>
                        {/* <button className="w-10 h-9 px-2 flex items-center justify-center rounded-md bg-brand-primaryColor">
                            <FaFilter className="text-white" />
                        </button> */}
                    </div>
                </div>

                <div className={`${!isLoading && currLocalMappedDev?.length === 0 ? "w-full flex justify-center items-center" : "overflow-y-scroll h-[23rem] scrollWidth"}`}>
                    {isLoading && currLocalMappedDev?.length === 0 ? (
                        <div className="flex items-center justify-center mt-[10%]"><Flex align="center" gap="middle"><Spin size="large" tip="Loading" /></Flex></div>
                    ) : currLocalMappedDev?.length === 0 ? (
                        <div className="flex flex-col items-center justify-center"><img src={nodatafound} alt="nodatafound" className="h-32 w-32" /><p className="font-medium text-xl">No data found!!</p></div>
                    ) : (
                        <MappedDevicesTable data={currLocalMappedDev} totalCount={currLocalMappedDev?.length} />
                    )}
                </div>

                <div className="mt-8">
                    <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3">
                        <button disabled={loader || !isRpmEnabled} className={`${currPageView > 1 ? "block" : "hidden"} md:min-w-24 w-[3rem] md:w-24 h-8 p-1 custom_filter text-white rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50`} onClick={handlePrevious}>Previous</button>
                        <button disabled={loader} className="md:min-w-24 w-[3rem] md:w-24 h-8 p-1 bg-white rounded-lg border border-brand-primaryColor text-brand-primaryColor font-semibold custom-button-shadow" onClick={handleCancel}>Cancel</button>
                        <button disabled={loader || !isRpmEnabled} className="md:min-w-24 w-[3rem] md:w-24 h-8 p-1 custom_filter text-white rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50" onClick={handlePatientFinalSave}>
                            {selectedEditPatient ? "Update" : "Save"}
                        </button>
                    </div>
                </div>
            </div>

            <Modal title="New Devices" footer={[]} open={deviceModal} onCancel={() => setDeviceModal(false)}>
                <AddDevices handleNewDeviceMod={() => setDeviceModal(false)} handlSetLocalMappedDevices={handlSetLocalMappedDevices} />
            </Modal>
        </>
    );
}

export default forwardRef(Devices);
